import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Google from "../assets/images/google.png";
import Facebook from "../assets/images/facebook.png";
import axios from "axios";

const ChangePasswordForget = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [succShowPopup, setSuccShowPopup] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    new_password: "",
  });
  const { pathname } = window.location;
  const userEmail = pathname.split("/").pop(); // Extract email from URL
  console.log(userEmail);

  // Show error popup with a specific message
  const handleShow = (message) => {
    setErrorMessage(message);
    setShowPopup(true);
    setShowPopup(true);
};
  const handleShow1 = (message) => {
    setSuccessMessage(message);
    setSuccShowPopup(true);

};

  // Close popup
  const handleClose = () => setShowPopup(false);
  const handleClose1 = () => setSuccShowPopup(false);

  const handleChangePass = async (event) => {
    event.preventDefault();
    try {

      // API call to login user
      const response = await axios.post(
        "https://printgraphibackend.testingwebsitelink.com/api/reset_password",
        {
          email: userEmail,
          new_password: formData.new_password,
        }
      );
      handleShow1(response.data.message);
      console.log("Login response:", response.data.message);
      navigate("/login");
      // Redirect to home page
    } catch (error) {
      // Display error message in popup
      if (error.response && error.response.data && error.response.data.message) {
        handleShow(error.response.data.message);
      } else {
        handleShow("An error occurred. Please try again.");
      }
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  return (
    <>
      <div className="register-bg-img">
        <div className="container">
          <div className="row">
            <div className="col-3"></div>
            <div className="col-lg-6 col-sm-12">
              <div className="accconec login-bg-color">
               
                <div className="account-body">
                  <h5 className="acc-title">Change your password</h5>
                  <form onSubmit={handleChangePass}>
                    
                    <div className="mb-3">
                      <input
                        type="password"
                        className="form-control"
                        placeholder="New Password"
                        value={formData.new_password}
                        onChange={handleChange}
                        name="new_password"
                        required
                      />
                    </div>
                 
                    
                    <div className="accbtn">
                      <button type="submit" className="singin">
                        Confirm
                      </button>
                      
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div className="col-3"></div>
          </div>
        </div>
      </div>

      {/* Bootstrap modal for error messages */}
      {showPopup && (
        <div
          className="modal fade show error"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Error</h5>
                <button
                  type="button"
                  className="close"
                  onClick={handleClose}
                >
                  &times;
                </button>
              </div>
              <div className="modal-body">
                <p>{errorMessage}</p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={handleClose}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {succShowPopup && (
        <div
          className="modal fade show error"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Success</h5>
                <button
                  type="button"
                  className="close"
                  onClick={handleClose1}
                >
                  &times;
                </button>
              </div>
              <div className="modal-body">
                <p>{successMessage}</p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={handleClose1}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ChangePasswordForget;
